// eslint-disable-next-line import/no-anonymous-default-export
export default {
  l10n: {
    currency: '\u20ac',
    date: {
      months: {
        full: [
          'janvier',
          'février',
          'mars',
          'avril',
          'mai',
          'juin',
          'juillet',
          'août',
          'septembre',
          'octobre',
          'novembre',
          'décembre',
        ],
        abbr: [
          'janv.',
          'févr.',
          'mars',
          'avr.',
          'mai',
          'juin',
          'juil.',
          'août',
          'sept.',
          'oct.',
          'nov.',
          'déc.',
        ],
      },
      days: {
        full: [
          'dimanche',
          'lundi',
          'mardi',
          'mercredi',
          'jeudi',
          'vendredi',
          'samedi',
        ],
        abbr: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
      },
      patterns: {
        longDate: 'dddd D MMMM YYYY',
        dateSlash: 'DD/MM/YYYY',
        dateShort: 'dddd D MMMM',
        dateShortWithDay: 'Do MMMM YYYY',
        dateMedium: 'dddd D MMMM - H[h]mm',
        dateMediumReversed: 'H[h]mm - D MMMM YYYY',
        dateMediumSlash: 'DD[/]MM[/]YYYY [à] H[h]mm',
        dateLarge: 'D MMM YYYY [à] HH[:]mm',
        timeShort: 'LT',
        timeMedium: 'DD[/]MM LT',
      },
    },
    number: {
      patterns: {
        standard: ['-n', 'n'],
        amount: ['-n S', 'n S'],
      },
      group: {
        separator: ' ',
        length: 3,
        abbr: ['', 'k', 'M', 'Md'],
      },
      decimal: {
        separator: ',',
        length: 2,
      },
      ordinal: function (number) {
        return number + (number === 1 ? 'er' : 'e');
      },
    },
  },
  translations: {
    messages: {
      Cart: [null, 'Panier'],
      Favourites: [null, 'Favoris'],
      Delivery: [null, 'Livraison'],
      Summary: [null, 'Récapitulatif'],
      Order: [null, 'Commande'],
      Categories: [null, 'Catégories'],
      'No results found': [null, 'Pas de résultat trouvé'],
      'No favourites': [null, 'Pas de favoris'],
      'Empty cart': [null, 'Panier vide'],
      'No order': [null, 'Pas de commande'],
      'Add to cart': [null, 'Ajouter au panier'],
      Included: [null, 'Incluse'],
      Delete: [null, 'Supprimer'],
      Items: [null, 'Articles'],
      Description: [null, 'Description'],
      Quantity: [null, 'Quantité'],
      Price: [null, 'Prix'],
      'Where would you like to receive your order?': [
        null,
        'Où souhaitez-vous recevoir votre commande?',
      ],
      Address: [null, 'Adresse'],
      'Address details': [null, "Complément d'adresse"],
      'Estimated delivery date': [null, 'Date estimée de livraison'],
      'Confirm delivery': [null, 'Valider la livraison'],

      Form: [null, 'Formulaire'],
      'Winamax account address': [null, 'Addresse de votre compte winamax'],
      'Other address': [null, 'Autre adresse'],
      'Please select an address in Europe': [
        null,
        'Veuillez sélectionner une adresse en Europe',
      ],
      'Search an address': [null, 'Rechercher une adresse'],
      'Please complete required fields': [
        null,
        'Veuillez remplir les champs requis',
      ],
      'Enter your personal information': [
        null,
        'Écrivez vos informations personnelles',
      ],
      'Address 2': [null, 'Adresse 2'],
      Postcode: [null, 'Code postal'],
      City: [null, 'Ville'],
      'Telephone number': [null, 'Numéro de téléphone'],
      'I agree for my account to be debited': [
        null,
        "J'accepte que mon compte soit débité",
      ],
      Confirmation: [null, 'Confirmation'],
      Save: [null, 'Enregistrer'],
      'View order': [null, 'Voir la commande'],
      'Back to the shop': [null, 'Retourner à la boutique'],
      Orders: [null, 'Commandes'],
      Pay: [null, 'Payer'],
      'Thank you': [null, 'Merci'],
      'We have received your order': [null, 'Nous avons reçu votre commande'],
      'You will receive a confirmation e-mail shortly': [
        null,
        'Vous recevrez dans un instant un e-mail de confirmation par mail.',
      ],
      'In progress': [null, 'En cours'],
      Completed: [null, 'Terminées'],
      'Order status': [null, 'Statut de la commande'],
      'Contact support': [null, 'Contacter le support'],
      'Track order': [null, 'Suivre le colis'],
      'Order date': [null, 'Date de commande'],
      'Order number': [null, 'Numéro de commande'],
      Sort: [null, 'Trier'],
      Miles: [null, 'Miles'],
      'View results': [null, 'Voir les résultats'],
      Recommended: [null, 'Recommandés'],
      'Price ascending': [null, 'Prix croissant'],
      'Price descending': [null, 'Prix décroissant'],
      'Show only products I can buy': [
        null,
        'Afficher uniquement les produits que je peux acheter',
      ],
      Under: [null, 'Moins de'],
      Over: [null, 'Plus de'],
      Validate: [null, 'Valider'],
      Cancel: [null, 'Annuler'],
      'Confirm cancellation': [null, 'Confirmation de la suppression'],
      'Are you sure you want to delete this item?': [
        null,
        'Êtes-vous sur de vouloir supprimer cet élément?',
      ],
      'Product added to favorites': [null, 'Produit ajouté au favoris'],
      'Product added to cart': [null, 'Produit ajouté au panier'],
      See: [null, 'Voir'],
      'PRICE CHANGE': [null, 'CHANGEMENT DE PRIX'],
      'The price of the %1$s product has changed. It will be adjusted in your cart.':
        [
          null,
          'Le prix du produit %1$s a évolué.  Il sera ajusté dans votre panier.',
        ],
      'QUANTITY UNAVAILABLE': [null, 'QUANTITÉ INDISPONIBLE'],
      'We are sorry, the %1$s product is no longer available in the quantity you selected.':
        [
          null,
          "Nous sommes désolé, le produit %1$s n'est plus disponible dans la quantité que vous aviez selectionner.",
        ],
      'Product unavailable': [null, 'Produit Indisponible'],
      'We are sorry, the %1$s product is no longer available. It will be removed from your cart.':
        [
          null,
          "Nous sommes désolé, le produit %1$s n'est plus disponible. Il sera supprimé de votre panier.",
        ],
      Phone: [null, 'Téléphone'],
      All: [null, 'Tout'],
      Maintenance: [null, 'Maintenance'],
      Fitting: [null, 'Fitting'], // This is not translated, as "Fitting" might have different meanings. You might want to provide a context or use a French equivalent like "Montage" or "Ajustement" based on the context.
      Manufacturer: [null, 'Fabrication'],
      Back: [null, 'Retour'],

      // ORDER STATUS
      'Order ready for delivery': [null, 'Commande prête à partir'],
      'Order being prepared': [null, 'Commande en préparation'],
      'Order in process': [null, 'Commande en traitement'],
      'Order being delivered': [null, 'Commande en cours de livraison'],
      'This order requires some action on your part': [
        null,
        'Commande nécessitant votre intervention',
      ],
      'Order being processed manually': [
        null,
        'Commande en cours de traitement manuel',
      ],
      'Order completed': [null, 'Commande terminée'],
      'Order returned': [null, 'Commande retournée'],
      'Order cancelled': [null, 'Commande annulée'],
      'Order resubmitted': [null, 'Commande relancée'],
      'Order refunded': [null, 'Commande remboursée'],

      // CART ERRORS
      IMPORTANT: [null, 'ATTENTION'],
      'Some products could not be ordered due to %1$s. \n You can find them in your cart.':
        [
          null,
          "Certains produits n'ont pas pu être commandés à cause de %1$s. \n Vous pouvez les retrouver dans votre panier.",
        ],
      CONFIRM: [null, 'VALIDER'],
      'Unable to order': [null, 'Commande impossible'],
      'Your order could not be completed because of %1$s': [
        null,
        "Votre commande n'a pu aboutir suite à %1$s",
      ],
      'Your order could not be completed': [
        null,
        'Votre commande n’a pas pu aboutir',
      ],
      'Back to cart': [null, 'Retour au panier'],

      // DEBIT MILES ERRORS
      'an identical order in progress': [
        null,
        'Une autre commande identique en cours',
      ],
      'a technical error': [null, 'une erreur technique'],
      'an error in the recipient of the bonus': [
        null,
        'Une erreur sur le destinataire du bonus',
      ],
      'an insufficient Miles balance': [null, 'Un solde de miles insuffisant'],
      'a deposit limit reached on your account': [
        null,
        'une limite de dépôt atteinte sur votre compte',
      ],
      'You cannot offer this product to this player': [null, 'Ce compte ne peut pas recevoir de cadeaux'],

      // ADDITIONAL TRANSLATIONS
      'Log in to order': [null, 'Se connecter'],
      'Delete all filters': [null, 'Réinitaliser tous les filtres'],
      Materials: [null, 'Matières'],
      'Next availability': [null, 'Prochaine disponibilité'],
      'All categories': [null, 'Tout voir'],
      Filters: [null, 'Filtres'],
      'See all': [null, 'Voir tout'],
      'Check Details': [null, 'Voir les détails'],
      'Place Order': [null, 'Commander'],
      'Enter a nickname': [null, 'Entrez un pseudo'],
      View: [null, 'Voir'],
      'Your order will be shipped in multiple shipments': [
        null,
        'Votre commande sera expédiée en plusieurs envois',
      ],
      Offer: [null, 'Offrir'],
      'Express order': [null, 'Achat express'],
      Buy: [null, 'Acheter'],
      'Not enough miles. Please remove some items.': [
        null,
        'Pas assez de miles. Veuillez retirer des articles.',
      ],
      'Not enough miles available for immediate order': [
        null,
        'Pas assez de miles disponibles pour un achat express',
      ],
      'Place order': [null, 'Commander'],
      Confirm: [null, 'Confirmer'],
      'Empty Cart': [null, 'Vider le panier'],
      'Please select colors and/or size': [
        null,
        'Veuillez sélectionner couleur(s) et/ou taille',
      ],
      'Dematerialized product': [null, 'Produit dématérialisé'],
      Message: [null, 'Message'],
      MILES: [null, 'MILES'],
    },
  },
};
